// O painel de indicadores da tela de Relatórios.
//
// O conteúdo virou peça (componentes/PanoramaDoNucleo), porque esta tela e
// a de Início mostravam os mesmos quatro números com títulos, ordem e
// textos de apoio diferentes.
//
// `isAdmin` continua na assinatura porque App.js o passa; não muda nada
// aqui — quem escolhe o núcleo é o seletor do cabeçalho.
import PanoramaDoNucleo from "../componentes/PanoramaDoNucleo";

export default function Resumo({ nucleo }) {
  return <PanoramaDoNucleo nucleo={nucleo} mostrarQuemRegistrou />;
}
